import { IconButton } from "@mui/material";
import { MoreHoriz } from "@mui/icons-material";
import { useState } from "react";
import { useTranslation } from "react-i18next";
import { EmptyRowsFallback } from "src/components/Grid/EmptyRowsFallback";

import { MRTGrid } from "@foodpilot/foods";
import { useProductListContext } from "../ProductListContext";
import { ActionsPopover } from "../Popover/ActionsPopover";

export const ProductGrid = () => {
    const { t } = useTranslation();
    const {
        mrt_columns,
        products,
        delayedSearchProduct,
        totalItems,
        productPage,
        setProductPage,
        sorting,
        setSorting,
    } = useProductListContext();

    //popover state
    const [rowMenuAnchor, setRowMenuAnchor] = useState<null | HTMLElement>(null);
    const [selectedRowItemId, setSelectedRowItemId] = useState<number | null>(null);

    return (
        <>
            <MRTGrid
                columns={mrt_columns.mrt_columns}
                data={products ?? []}
                globalFilterFn="contains"
                enableRowActions={true}
                enableRowSelection={false}
                enablePagination={true}
                enableSelectAll={false}
                enableColumnPinning={true}
                displayColumnDefOptions={{
                    "mrt-row-actions": {
                        size: 80,
                        grow: false,
                    },
                }}
                renderRowActions={({ row }) => {
                    return (
                        <IconButton
                            onClick={(e) => {
                                setSelectedRowItemId(row.original.id);
                                setRowMenuAnchor(e.currentTarget);
                            }}
                            sx={{
                                transform: "translateX(-4px)",
                            }}
                        >
                            <MoreHoriz />
                        </IconButton>
                    );
                }}
                renderEmptyRowsFallback={() => <EmptyRowsFallback message={t("Il n'y a aucun produit à afficher")} />}
                state={{
                    isLoading: products === undefined,
                    globalFilter: delayedSearchProduct,
                    columnVisibility: mrt_columns.columnVisibility,
                    columnOrder: mrt_columns.columnOrder,
                    pagination: productPage,
                    columnPinning: {
                        left: [mrt_columns.columnOrder[0]],
                        right: ["mrt-row-actions"],
                    },
                    columnSizing: mrt_columns.columnSizing,
                    sorting: sorting,
                }}
                onColumnSizingChange={mrt_columns.setColumnSizing}
                // Server-side pagination
                rowCount={totalItems}
                manualPagination={true}
                onPaginationChange={setProductPage}
                localization={{
                    actions: "",
                }}
                manualSorting={true}
                onSortingChange={setSorting}
            />
            <ActionsPopover
                allProducts={products ?? []}
                selectedRowItemId={selectedRowItemId}
                anchor={rowMenuAnchor}
                setAnchor={setRowMenuAnchor}
                closeWindow={() => setRowMenuAnchor(null)}
            />
        </>
    );
};
